<template>
  <div class='MakeCardCheck'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { handleCofirm } from '@/utils'

const sexProps = { label: 'name', value: 'id' }

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging,
  },
  data () {
    // 这里存放数据
    return {
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },
      asyncData: { // 接口请求回来的数据
        cardTypeList: []
      },
      search: { // 搜索
        searchData: {
          interst: []
        }, // 返回的数据
        searchForm: [
          { type: 'Input', label: '账号：', prop: 'cardNo', placeholder: '请输入账号' },
          { type: 'Select', label: '账号类型：', prop: 'cardTypeId', width: '180px', options: this.cardTypeList, props: sexProps, change: row => '', placeholder: '请选择账号类型' },
        //   { type: 'Input', label: '充值次数：', prop: 'czcs', placeholder: '请输入充值次数' },
          { type: 'Input', label: '会员ID：', prop: 'bindAccount', placeholder: '请输入会员ID' },
          { type: 'Input', label: '账号名称：', prop: 'bindAccountName', placeholder: '请输入账号名称' },

        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },
      cardNatureObj:{
        0: '定额卡',
        1: '不定额卡',
        2: '动态充值卡'
      },
      Table: { // 表格
        selectionHandle: (v) => this.selectionHandle(v),
        primaryBtn: {
          show: true,
          html: '通过',
          handle: (el) => this.dynamiCardPass(el,1)
        },
        defaultBtn: {
          show: true,
          html: '驳回',
          handle: (el) => this.dynamiCardPass(el,2)
        },
        selectedList: [], // 选中的list
        data: [],
        column: [
          { type: 'selection' },
          { prop: 'cardNo', label: '账号' },
          { prop: 'cardTypeName', label: '账户类型' },
          { prop: 'rechargeAmount', label: '充值金额' },
          { prop: 'bindAccount', label: '会员ID' },
          { prop: 'bindAccountName', label: '账号名称' },
          { prop: 'createTime', label: '充值日期' }
        ]
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    searchHandleForm () {
      this.getItemList()
    },
    searchResetForm () {
      this.search.searchData = {}
    },

    getItemList () { // 获取列表
      const { pager, search } = this
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        cardNature: 2,
        ...search.searchData,
        status: 0
      }
      this.$http.getDynamiCardList(params)
        .then((res) => {
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = (res.data.list || []).map((item) => ({
              ...item,
              cardNatureName: this.cardNatureObj[item.cardNature]
            }))
          }
        })
    },

    selectionHandle (v) {
      this.Table.selectedList = v
    },

    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            this.asyncData.cardTypeList = res.data
            this.search.searchForm.forEach((item) => {
              if (item.prop == 'cardTypeId') {
                item.options = res.data
              }
            })
          }
        })
    },
    // 通过 & 驳回
    dynamiCardPass (el,status) { 
        // el是表格的ref // status 1通过 2驳回
        if(this.Table.selectedList.length===0){
          this.$message.warning('至少选择一张卡')
          return
          }
         handleCofirm('确认当前操作?', 'type').then(async () => {
            const ids = this.Table.selectedList.map(item=>{
                return item.id
            })
            const params = {
                ids: ids.join(','),
                status 
            }
            this.$http.dynamiCardPass(params)
            .then((res) => {
            if (res.status === 200) {
                el.clearSelection()
                this.getItemList()
                this.$message.success(res.msg || '操作成功')
            }
            }).catch((err)=>{
                this.$message.error(res.msg)
            })
        }).catch(() => { 

        })
    },

    // 初始化
    init () {
      this.getItemList()
      this.getCardTypeList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
  .el-checkbox {
    width: 25%;
    margin-right: 0;
    &:nth-child(n + 4) {
      margin-top: 20px;
    }
  }
}
</style>
